export default __webpack_public_path__ + "static/media/project01.777e687a.PNG";